<template>
  <div class="tr">
    <div class="td flex-col uppercase items-start">
      <span class="font-bold text-left">{{ dealer.company }}</span>
      <div class="flex flex-col text-xs">
        <span>{{ dealer.address1 }}</span>
        <span>{{ dealer.postcode}} {{ dealer.city }}  ({{ dealer.country }})</span>
        <span>{{ dealer.email }}</span>
      </div>
    </div>
    <div class="td px-2">
      <input type="checkbox" :checked="dealer.visible">
    </div>

  </div>
</template>

<script>
export default {

  props: ['dealer']

}
</script>

<style scoped>

</style>